import { Link, Button } from "@heroui/react";

export default function CTA() {
  return (
    <div className="flex flex-col items-center justify-center w-full pb-16">
      {/* Button */}
      <div className="-translate-y-[10px] flex justify-center w-full md:w-auto">
        <Link href="https://app.mash.fun/" target="_blank" className="w-max">
          <Button
            radius="full"
            className="gradient-wild-bg text-white px-9 py-6 rounded-lg text-lg"
          >
            Start Trading
          </Button>
        </Link>
      </div>
    </div>
  );
}
